(function () {
  const BASE_URL = 'https://website-api-uat-eu.dreo-tech-uat.com';
  const AUTH_TOKEN_KEY = '__us-east-2__auth_token__';
  const SUBSCRIBE_URL = `${BASE_URL}/api/support/product/subscribe`;

  function validateEmail(email) {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  }

  async function getAuthToken() {
    try {
      const url = `${BASE_URL}/api/oauth/login?timestamp=${Date.now()}&lang=en-US`;
      const res = await fetch(url, {
        method: 'POST',
        body: JSON.stringify({
          "grant_type": "client_credentials",
          "scope": "all",
          "client_id": "6c2bfbdd497f4addbb77449edd3d73ec",
          "client_secret": "460df321de794ea08110cb3ed32c7452"
      }),
        headers: {
          'hs-user-agent': 'website/dreo-official-us',
          'Content-Type': 'application/json',
        },
      });
      const { data } = await res.json();
      Cookies.set(AUTH_TOKEN_KEY, data.access_token, { expires: 7, domain: '.dreo.com' });
      return data
    } catch (err) {
    }
  }

  async function submitSubscription(email, tag, form, retried = false) {
    try {
      if (!validateEmail(email)) {
        const errorTip = form.querySelector('.as-error-tips');
        errorTip?.classList.remove('d-none');
        return;
      }

      let authToken = Cookies.get(AUTH_TOKEN_KEY);

      if (!authToken) {
        const data = await getAuthToken();
        authToken = data.access_token;
      }

      const data = {
        email,
        subscribeType: 'CROWDFUNDING',
        entrance: 'subscription-form',
        customTags: tag ? [tag] : [],
        timestamp: Date.now(),
        country: 'UK'
      };

      const response = await fetch(`${SUBSCRIBE_URL}?${new URLSearchParams(data)}`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${authToken}`,
          'hs-user-agent': 'website/dreo-official-us',
        },
      });

      const result = await response.json();

      // 处理401错误，重新获取token并重试
      if (result.code === 401 && !retried) {
        await getAuthToken();
        return submitSubscription(email, tag, form, true);
      }

      if (result.code === 0) {
        // 获取是否显示模态框的配置
        const showModal = form.getAttribute('data-show-modal') !== 'false';
        
        if (showModal) {
          // 原有逻辑：显示模态框
          const modal = form.querySelector('.subscription-form-modal');
          modal.show();
        } else {
          // 新增逻辑：显示成功提示
          const successTip = form.querySelector('.as-success-tips');
          successTip?.classList.remove('d-none');
        }
      } else {
        throw new Error(result.message);
      }
    } catch (err) {
      const errorTip = form.querySelector('.as-error-tips');
      errorTip?.classList.remove('d-none');
    }
  }

  // 初始化
  async function init() {
    const forms = document.querySelectorAll('.dr-subscription-form:not([initialized])');
    if (!forms.length) return;

    const authToken = Cookies.get(AUTH_TOKEN_KEY);
    if (!authToken) {
      await getAuthToken();
    }

    forms.forEach((form) => {
      form.setAttribute('initialized', 'true');

      const submitButton = form.querySelector('button[type="submit"]');
      submitButton?.addEventListener('click', async (e) => {
        e.preventDefault();

        const emailInput = form.querySelector('input[name="contact[email]"]');
        const tagInput = form.querySelector('input[name="contact[tags]"]');

        const errorTip = form.querySelector('.as-error-tips');
        errorTip?.classList.add('d-none');
        const successTip = form.querySelector('.as-success-tips');
        successTip?.classList.add('d-none');

        await submitSubscription(emailInput?.value, tagInput?.value, form);
      });
    });
  }

  init();
})();
